import React from "react";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportNonCoveredPricingModal = ({ onImport, labId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      lab_id: labId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/non_covered_pricings/background_import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Non-Covered Pricing..."
      exampleDownloadPath="/admin/non_covered_pricings/example"
    ></ImportModal>
  );
};
